import React, { Component } from 'react';
import styles from './dot-indicator.scss';
import { DragSource, DropTarget } from 'react-dnd';

const bgSource = {
  beginDrag({ arrayId, index }) {
    return { arrayId, index };
  }
};

const bgTarget = {
  canDrop(props, monitor) {
    return props.arrayId === monitor.getItem().arrayId;
  },
  drop(props, monitor, component: Dot) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
  
    // Don't replace items with themselves
    if (dragIndex === hoverIndex) return;
    
    monitor.getItem().index = hoverIndex;
    props.onSort(dragIndex, hoverIndex);
  }
};

type Props = {
  className?: string,
  index?: number,
  onClick?: number => void
  
};
type State = {};

@DropTarget('dot', bgTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver() && monitor.canDrop()
}))
@DragSource('dot', bgSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}))
export default class Dot extends Component {
  props: Props;
  state: State = {};
  
  index;
  
  constructor(props) {
    super(props);
    
    this.index = props.index;
  }
  
  render() {
    const {
      className,
      connectDragPreview,
      connectDragSource,
      connectDropTarget,
      index,
      isOver,
      onClick
    } = this.props;
    
    return (
      connectDragPreview(
        connectDropTarget(
          <div className={styles.dotAndDrop}>
            {connectDragSource(
              <div
                className={className + (isOver ? (' ' + styles.dragMarker) : '')}
                onClick={() => onClick(index)}
                ref={ref => this.container = ref}
              />
            )}
          </div>
        )
      )
    );
  }
}
